var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{},[_c('div',{staticClass:"text-blue-800 py-4"},[_vm._v(" Styling template: "+_vm._s(_vm.stylingTemplate)+" ")]),_c('div',{attrs:{"id":"gjs"}}),_c('div',{attrs:{"id":"blocks"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }